import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
// import toaster from 'utils/toaster';

export interface ISaveScheduleData {
  id: string;
  title: string;
  description: string;
  job_id: number;
  event_pid: string;
  timezone: string | null;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  repeat: boolean;
  all_day: boolean;
  repeat_type: string;
  weeks: string;
  repeat_end_date: string;
  color: string;
  user_ids: number[];
  publish: boolean;
  update_series: boolean;
  street: string;
  city: string;
  state: string;
  country: string;
  zip_code: string;
  use_different_address: boolean;
}

const saveSchedule = ({ id, ...postData }: ISaveScheduleData) => {
  if (id) {
    const newEndpoints = endpoints.scheduling.scheduleById.replace('{id}', id);
    return http().put(newEndpoints, { id, ...postData });
  } else {
    return http().post(endpoints.scheduling.base, postData);
  }
};

export function useSaveSchedule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveSchedule,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchCalendarView'] });
      }
    },
  });
}
